import { Component, HostBinding, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MStepper } from '@argalis-apps/angular-global';
import { MFormation, MResa } from '@argalis-apps/models';
import { CommanditaireComponent } from '../commanditaire/commanditaire.component';
import { ConfirmationComponent } from '../confirmation/confirmation.component';
import { FormOptionComponent } from '../form-option/form-option.component';
import { NombreParticipantComponent } from '../nombre-participant/nombre-participant.component';
import { CartService } from '../../services/cart/cart.service';
import { CartConfigService } from '../../services/cart-config/cart-config.service';
import { AccountService } from '../../../account/services/account/account.service';
import { AuthService } from '../../../auth/services/auth/auth.service';
import { forkJoin } from 'rxjs';
import { FormOptionService } from '../../services/cart/form-option/form-option.service';

@Component({
  selector: 'ags-reservation',
  templateUrl: './reservation.component.html',
  styleUrls: ['./reservation.component.scss']
})
export class ReservationComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  @ViewChildren(MStepper.StepperDirective) stepperHost: QueryList<MStepper.StepperDirective>;

  public orderSteps: MStepper.IStep[] = [];
  public currentResa: MResa.IResa;
  public currentFormation: MFormation.CFormInfo;
  public optionInfo: MFormation.COptionInfo;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private accountService: AccountService,
    private cartConfigService: CartConfigService,
    private cartService: CartService,
    private router: Router,
    private formOptionService: FormOptionService
  ) {
    if (!this.authService.userConnected) this.router.navigate(this.authService.getRoute('signup'));
  }

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.cartConfigService.themingClassName}`;
    this.route.params.subscribe((params: Params) => {
      const cartList = this.cartService.getCart();
      this.currentResa = cartList.find(cart => Number(cart.id || 0) === Number((params || ({} as any)).id || -1));
      this.currentFormation = new MFormation.CFormInfo((this.currentResa || ({} as any)).formation);
      forkJoin(this.formOptionService.getOptionInfo(Number(this.currentFormation.id))).subscribe(res => {
        this.optionInfo = new MFormation.COptionInfo(res[0]);
        this.orderSteps = [
          {
            rank: 0,
            title: 'ASSISTANT DE COMMANDE',
            active: false,
            locked: true,
            component: null,
            condition: () => true,
            validation: null
          },
          {
            rank: 2,
            title: 'Identification du commanditaire',
            active: true,
            locked: false,
            component: CommanditaireComponent,
            condition: () => !this.accountService.checkProfileCompletion(this.authService.userConnected),
            validation: () => {
              // test d'unicité du siret en base
              // dataInput => SIRET error ?
              return true;
            }
          },
          // {
          //   rank: 2,
          //   title: 'Choix des options',
          //   active: this.accountService.checkProfileCompletion(this.authService.userConnected),
          //   locked: !this.accountService.checkProfileCompletion(this.authService.userConnected),
          //   dataInput: this.currentFormation,
          //   component: FormOptionComponent,
          //   condition: () => this.optionInfo.hasOptions,
          //   validation: () => this.secondStepValidation(),
          //   backStep: null
          // },
          {
            rank: 2,
            title: 'Participants',
            active: !(
              !this.accountService.checkProfileCompletion(this.authService.userConnected) || this.optionInfo.hasOptions
            ),
            locked:
              !this.accountService.checkProfileCompletion(this.authService.userConnected) || this.optionInfo.hasOptions,
            dataInput: this.currentResa,
            component: NombreParticipantComponent,
            condition: () => {
              if (this.authService.userConnected.company.type === 'PART') {
                // => fonction pour positionner l'apprenant unique du client particulier
                return false;
              }
              return true;
            },
            validation: () => this.thirdStepValidation(),
            backStep: null
          },

          // {
          //   rank: 3,
          //   title: 'Participants',
          //   active: !(
          //     !this.accountService.checkProfileCompletion(this.authService.userConnected) ||
          //     this.currentFormation.hasOptions
          //   ),
          //   locked:
          //     !this.accountService.checkProfileCompletion(this.authService.userConnected) ||
          //     this.currentFormation.hasOptions,
          //   dataInput: this.currentResa,
          //   component: ParticipantComponent,
          //   condition: () => {
          //     if (this.authService.userConnected.company.type === 'PART') {
          //       // => fonction pour positionner l'apprenant unique du client particulier
          //       return false;
          //     }
          //     return true;
          //   },
          //   validation: () => this.thirdStepValidation(),
          //   backStep: null
          // },
          {
            rank: 3,
            title: 'Confirmation',
            active: !(
              !this.accountService.checkProfileCompletion(this.authService.userConnected) ||
              this.optionInfo.hasOptions ||
              this.authService.userConnected.company.type !== 'PART'
            ),
            locked:
              !this.accountService.checkProfileCompletion(this.authService.userConnected) ||
              this.optionInfo.hasOptions ||
              this.authService.userConnected.company.type !== 'PART',
            dataInput: this.currentResa,
            component: ConfirmationComponent,
            condition: () => true,
            backStep: null
          }
        ];
      });
    });
  }

  secondStepValidation(): boolean {
    let count = 0;
    for (const opt of this.currentFormation.optionInfo.options) {
      if (opt.subscribed) count += 1;
    }
    return this.currentFormation.optionInfo.maxOptions >= count && count > 0;
  }

  thirdStepValidation(): boolean {
    //  return this.currentResa.participants && this.currentResa.participants.length > 0;
    return this.currentResa.nb_places_reserve && this.currentResa.nb_places_reserve > 0;
  }
}
